import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, BookOpen } from "lucide-react";

export default function OEMResearch() {
  const [mans, setMans] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/oem/manufacturers").then((r) => setMans(r.data));
  }, []);

  const filtered = mans.filter((m) => !q || m.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-6 animate-slide-up" data-testid="oem-page">
      <div>
        <div className="text-xs uppercase tracking-[0.22em] text-slate-500 font-bold mb-2">OEM Intelligence Center</div>
        <h1 className="font-display text-4xl font-semibold tracking-tight">OEM Procedures & Compliance</h1>
        <p className="text-sm text-slate-400 mt-1.5">Searchable database of calibration procedures across 25+ manufacturers.</p>
      </div>

      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
        <Input
          data-testid="oem-search-input"
          placeholder="Search manufacturer..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="pl-9 bg-[#0B1120] border-slate-800 h-10"
        />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {filtered.map((m) => (
          <Link key={m.slug} to={`/oem/${m.slug}`} data-testid={`oem-card-${m.slug}`} className="rounded-xl border border-slate-800 bg-[#0B1120] p-5 hover:border-blue-500/40 hover:translate-y-[-1px] transition-all group">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3 font-bold text-white text-lg" style={{ backgroundColor: m.color || "#1e293b" }}>
              {m.name.charAt(0)}
            </div>
            <div className="font-display text-sm font-semibold">{m.name}</div>
            <div className="text-[10px] uppercase tracking-wider text-slate-500 mt-1">{m.country}</div>
            <div className="text-xs text-blue-400 mt-3 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1">
              <BookOpen className="w-3 h-3" /> Procedures →
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
